module.exports = __webpack_public_path__ + "img/04桂建雄.59fe118b.jpg";